export default __webpack_public_path__ + "static/media/user.e6e4d80b.svg";